import styled from 'styled-components'

// export const StyledVideo  = styled.video`
//     width: 100%;
//     height: 500px;
//     @media screen and (max-width: 576px) {
//         width: 100%;
//         height: 200px;
//     }
// `

export const StyledVideo  = styled.iframe`
    width: 100%;
    height: 500px;
    border: none;
    @media screen and (max-width: 576px) {
        width: 100%;
        height: 200px;
    }
`